import { Routes } from '@angular/router';

export const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    loadComponent: () =>
      import('./page/search-page/search-page.component').then(
        module => module.SearchPageComponent
      ),
  },
  {
    path: 'story-viewer',
    pathMatch: 'full',
    loadComponent: () =>
      import('./page/story-viewer-page/story-viewer-page.component').then(
        module => module.StoryViewerPageComponent
      ),
  },
  {
    path: 'avatar-downloader',
    pathMatch: 'full',
    loadComponent: () =>
      import(
        './page/avatar-downloader-page/avatar-downloader-page.component'
      ).then(module => module.AvatarDownloaderPageComponent),
  },
  {
    path: 'photo-downloader',
    pathMatch: 'full',
    loadComponent: () =>
      import(
        './page/photo-downloader-page/photo-downloader-page.component'
      ).then(module => module.PhotoDownloaderPageComponent),
  },
  {
    path: 'reel-downloader',
    pathMatch: 'full',
    loadComponent: () =>
      import('./page/reel-downloader-page/reel-downloader-page.component').then(
        module => module.ReelDownloaderPageComponent
      ),
  },
  {
    path: 'video-downloader',
    pathMatch: 'full',
    loadComponent: () =>
      import(
        './page/video-downloader-page/video-downloader-page.component'
      ).then(module => module.VideoDownloaderPageComponent),
  },
  {
    path: 'about-project',
    pathMatch: 'full',
    loadComponent: () =>
      import('./page/about-project-page/about-project-page.component').then(
        module => module.AboutProjectPageComponent
      ),
  },
  {
    path: 'privacy-policy',
    pathMatch: 'full',
    loadComponent: () =>
      import('./page/privacy-policy-page/privacy-policy-page.component').then(
        module => module.PrivacyPolicyPageComponent
      ),
  },
  {
    path: 'cookie-policy',
    pathMatch: 'full',
    loadComponent: () =>
      import('./page/cookie-policy-page/cookie-policy-page.component').then(
        module => module.CookiePolicyPageComponent
      ),
  },
  {
    path: 'terms-and-conditions',
    pathMatch: 'full',
    loadComponent: () =>
      import(
        './page/terms-and-conditions-page/terms-and-conditions-page.component'
      ).then(module => module.TermsAndConditionsPageComponent),
  },
  {
    path: 'profiles/:username',
    pathMatch: 'full',
    loadComponent: () =>
      import('./page/profile-page/profile-page.component').then(
        module => module.ProfilePageComponent
      ),
  },
  {
    path: '404',
    pathMatch: 'full',
    loadComponent: () =>
      import('./page/not-found-page/not-found-page.component').then(
        module => module.NotFoundPageComponent
      ),
  },
  { path: '**', redirectTo: '404' },
];
